import type { DataSource } from "@firecms/core";
import {
  userPublicProfilesCollection,
  type UserPublicProfile,
} from "../collections/userPublicProfiles";

const CHUNK_SIZE = 30;

type DataSourceFetcher = Pick<DataSource, "fetchEntity">;

/**
 * Loads display names via individual `fetchEntity` (userPublicProfiles allows
 * get for any signed-in user, but list only for super managers).
 */
export async function fetchUserDisplayNames(
  dataSource: DataSourceFetcher,
  uids: string[]
): Promise<Map<string, string>> {
  const unique = [...new Set(uids.filter(Boolean))];
  const result = new Map<string, string>();
  if (unique.length === 0) return result;

  for (let i = 0; i < unique.length; i += CHUNK_SIZE) {
    const chunk = unique.slice(i, i + CHUNK_SIZE);
    const entities = await Promise.all(
      chunk.map((uid) =>
        dataSource.fetchEntity<UserPublicProfile>({
          path: "userPublicProfiles",
          entityId: uid,
          collection: userPublicProfilesCollection,
        })
      )
    );
    for (let j = 0; j < chunk.length; j++) {
      const displayName = entities[j]?.values?.displayName;
      const trimmed = displayName?.trim();
      if (trimmed) {
        result.set(chunk[j]!, trimmed);
      }
    }
  }

  return result;
}

export function participantBaseLabel(
  uid: string,
  participantNumber?: number
): string {
  if (participantNumber != null) {
    return `Cupo ${participantNumber}`;
  }
  return uid;
}
